import React from "react";
import { useTranslation } from "react-i18next";
import convert from "convert-units";
import { PARAMETER_OPTIONS } from "../../constants";
import { rpeValue } from "../../utils/rpe-range";

const { LOAD, RPE, RPEAMRAP, REPS } = PARAMETER_OPTIONS;

import { getRestTime } from "../../utils/converters/time-helper";
import { getLoadDrop } from "../../utils/load-drop";
import { repsValue } from "../../utils/reps-range";
import SvgIcon from "../SvgIcon";

export const CustomParametersSets = ({
  selectedExercise: { parameters },
  sets,
  locals,
  handleReorderSet,
  handleSetEditModeToggle,
  handleRemoveSet,
  editSetBackup,
  intensityMeasure,
  isRiR,
  isEditing,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <>
      <div className="set-labels">
        <p className="invisible">-</p>
        {parameters.map((elem) => (
          <p key={elem} className={`p4 ${elem}`}>
            {[RPE, RPEAMRAP].includes(elem) ? intensityMeasure : elem}
          </p>
        ))}
        <p className="p4">{t("customParametersSets.restTime")}</p>
        <p className="invisible">-</p>
      </div>
      <div className="set-list">
        {sets.map((set, index) => {
          const editMode = set.editMode || false;
          const notEditing = isEditing && !editMode;

          return (
            <div
              className={`Add-Exercise-Set${notEditing ? " not-editing" : ""}`}
              data-order={index}
              key={index}
            >
              <div
                className={`flex items-center gap-2${
                  sets.length <= 1 ? " invisible" : ""
                }`}
              >
                <button
                  data-button-type="secondary"
                  disabled={index === sets.length - 1 || isEditing}
                  onClick={(e) => {
                    e.preventDefault();
                    handleReorderSet(1, index);
                  }}
                >
                  <SvgIcon src="/img/new-icons/arrow-square-down.svg" />
                </button>
                <button
                  data-button-type="secondary"
                  disabled={index === 0 || isEditing}
                  onClick={(e) => {
                    e.preventDefault();
                    handleReorderSet(-1, index);
                  }}
                >
                  <SvgIcon src="/img/new-icons/arrow-square-up.svg" />
                </button>
              </div>

              {parameters.map((elem) => {
                let displayValue;
                if (elem === LOAD) {
                  if (set.loadDrop) {
                    displayValue = getLoadDrop(set.loadDrop);
                  } else if (
                    ["0", "", undefined].includes(set[mapParameter(elem)])
                  ) {
                    displayValue = "";
                  } else {
                    displayValue = locals.withWeight(
                      locals.activeUser.units === "imperial"
                        ? convert(set[mapParameter(elem)]).from("kg").to("lb")
                        : set[mapParameter(elem)]
                    );
                  }
                } else if ([RPE, RPEAMRAP].includes(elem)) {
                  displayValue = rpeValue(set.rpe, set.rpeLower, isRiR);
                } else if (elem === REPS) {
                  displayValue = repsValue(set.reps, set.repsLower);
                } else {
                  displayValue = set[mapParameter(elem)];
                }

                return (
                  <p className={elem} key={`${elem}_${index}`}>
                    {displayValue}
                  </p>
                );
              })}
              <p>{getRestTime(set, locals.activeUserToRequest)}</p>

              <div className="flex items-center gap-2">
                <button
                  data-button-type="secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSetEditModeToggle(index);
                  }}
                  className={isEditing ? "invisible" : ""}
                >
                  <SvgIcon src="/img/new-icons/edit-pencil.svg" />
                </button>
                <button
                  data-button-type="secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    if (editMode) {
                      handleSetEditModeToggle(index, editSetBackup);
                      return;
                    }
                    handleRemoveSet(index);
                  }}
                  className={notEditing ? "invisible" : ""}
                >
                  <SvgIcon
                    src={
                      editMode
                        ? "/img/new-icons/red-cross.svg"
                        : "/img/new-icons/red-trash.svg"
                    }
                    noFilterOnLight
                  />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

// used for parameters form
export const mapParameter = (element) => {
  if (element === "RPE/AMRAP") {
    return "rpe";
  } else if (element === "Free-Form") {
    return "freeform";
  }

  return element.toLowerCase();
};

// Used to show the param name, mainly to swap RPE/AMRAP for RPE
export const parameterName = (parameter, isRiR = false) => {
  if (parameter === "RPE/AMRAP") {
    return isRiR ? "RiR" : "RPE";
  }

  return parameter;
};
